<template>
  <div class="equipment-wrapper">
    <div class="title">{{ utils.truncate(info.name, 14) }}</div>
    <b-img
      @click.prevent="$emit('onClick', info, true)"
      class="e-saru"
      :src="info.thumbnail"
    />
    <div class="equipments">
      <div class="e-item" v-for="f in fields" :key="f.key">
        <div
          v-if="
            items &&
            items[f.inx] > 0 &&
            meta[items[f.inx]] &&
            meta[items[f.inx]].thumbnail
          "
          :class="`border-item ${
            utils.getClzBgItem(meta[items[f.inx]]) || 'bg-commom'
          }`"
        >
          <b-img
            :src="meta[items[f.inx]].thumbnail"
            @click.prevent="$emit('onClick', meta[items[f.inx]], false)"
            :class="utils.getClzBgItem(meta[items[f.inx]]) || 'bg-commom'"
          />
        </div>

        <b-img class="bg-placeholder" v-else :src="f.icon" />
      </div>
      <div class="e-item">
        <b-img class="bg-placeholder" src="~@/assets/icons/ic-lock.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import icHead from "@/assets/icons/ic-head.png";
import icEyes from "@/assets/icons/ic-eyes.png";
import icHands from "@/assets/icons/ic-hands.png";
import icWeapon from "@/assets/icons/ic-weapon.png";
import icBody from "@/assets/icons/ic-body.png";

export default {
  name: "SaruEquipment",
  props: ["tokenId", "meta", "items", "saruInx"],
  data: () => ({
    info: {},
    fields: [
      { key: "head", inx: 1, icon: icHead },
      { key: "eyes", inx: 3, icon: icEyes },
      { key: "hands", inx: 4, icon: icHands },
      { key: "weapon", inx: 0, icon: icWeapon },
      { key: "body", inx: 2, icon: icBody },
    ],
  }),
  computed: {
    ...mapGetters("saru", ["saruInfo"]),
  },
  created() {
    this.$store
      .dispatch("saru/getById", this.tokenId)
      .then((data) => (this.info = data));
  },
  methods: {
    ...mapActions("saru", ["getById"]),
  },
};
</script>

<style lang="scss" scoped>
.equipment-wrapper {
  width: 128px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  .title {
    text-align: center;
    text-transform: uppercase;
    font-weight: 600;
    margin: 0;
    line-height: normal;
  }
  .e-saru {
    cursor: pointer;
    width: 128px;
    height: auto;
  }
  .equipments {
    gap: 16px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .e-item {
      cursor: pointer;
      img {
        width: 56px;
        height: 56px;
        background-size: cover;
        &.bg-placeholder {
          background-image: url("~@/assets/icons/item-placeholder.png");
        }
      }
      div {
        background-size: cover;
        img {
          width: 56px;
          height: 56px;
          background-size: cover;
          &.bg-commom {
            background-image: url("~@/assets/icons/common.png");
          }
          &.bg-un-commom {
            background-image: url("~@/assets/icons/un-common.png");
          }
          &.bg-rare {
            background-image: url("~@/assets/icons/rare.png");
          }
          &.bg-epic {
            background-image: url("~@/assets/icons/epic.png");
          }
          &.bg-legend {
            background-image: url("~@/assets/icons/legend.png");
          }
          &.bg-placeholder {
            background-image: url("~@/assets/icons/item-placeholder.png");
          }
        }
        &.bg-commom {
          background-image: url("~@/assets/icons/b-common.png");
        }
        &.bg-un-commom {
          background-image: url("~@/assets/icons/b-uncommon.png");
        }
        &.bg-rare {
          background-image: url("~@/assets/icons/b-rare.png");
        }
        &.bg-epic {
          background-image: url("~@/assets/icons/b-epic.png");
        }
        &.bg-legend {
          background-image: url("~@/assets/icons/b-legend.png");
        }
      }
    }
  }
}
</style>
